import { render, staticRenderFns } from "./SuggestMember.vue?vue&type=template&id=49bb77c9&scoped=true&"
import script from "./SuggestMember.vue?vue&type=script&lang=ts&"
export * from "./SuggestMember.vue?vue&type=script&lang=ts&"
import style0 from "./SuggestMember.vue?vue&type=style&index=0&id=49bb77c9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49bb77c9",
  null
  
)

export default component.exports